import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

const regExpFormFields = new RegExp('/catalog/forms/\\d/fields+$')

const usePermissions = (user) => {
  const location = useLocation()
  const [permissions, setPermissions] = useState({
    create: false,
    read: false,
    edit: false,
    erase: false,
    exportBtn: false,
    importBtn: false,
    permissionsBtn: false,
    rolPermissionsMoodulesBtn: false,
    cycleCountcycleOperationBtn: false,
    path: '',
  })

  useEffect(() => {
    const permissions = user?.userPermissions
    let listPermissions = []

    permissions.map((item) => {
      let moduleName = `${item?.module_info?.relative_link}`

      if (moduleName === location.pathname) {
        return (listPermissions = {
          create: item.access_retrieve,
          read: item.access_read,
          edit: item.access_edit,
          erase: item.access_delete,
          exportBtn: item.access_export,
          importBtn: item.access_import,
          path: item.module_info.relative_link,
        })
      }
      return null
    })

    permissions.map((item) => {
      let submoduleName = item.submodule_info?.relative_link
      if (submoduleName) {
        if (location.pathname.includes('new')) {
          const relativePath = location.pathname
            .split('new')[0]
            .replace(/.$/, '')
          const relativePathSplit = relativePath.split('/')
          const submodulePath = relativePathSplit[relativePathSplit.length - 1]
          if (submoduleName === `/${submodulePath}`) {
            return (listPermissions = {
              create: item.access_retrieve,
              read: item.access_read,
              edit: item.access_edit,
              erase: item.access_delete,
              exportBtn: item.access_export,
              importBtn: item.access_import,
              path: `${item.module_info.relative_link}/${submodulePath}`,
            })
          }
        }
        if (location.pathname.includes('edit')) {
          const relativePath = location.pathname
            .split('edit')[0]
            .replace(/.$/, '')
          const relativePathSplit = relativePath.split('/')
          const submodulePath = relativePathSplit[relativePathSplit.length - 1]
          if (submoduleName === `/${submodulePath}`) {
            return (listPermissions = {
              create: item.access_retrieve,
              read: item.access_read,
              edit: item.access_edit,
              erase: item.access_delete,
              exportBtn: item.access_export,
              importBtn: item.access_import,
              path: `${item.module_info.relative_link}/${submodulePath}`,
            })
          }
        }
        const relativePathSplit = location.pathname.split('/')
        const submodulePath = relativePathSplit[relativePathSplit.length - 1]
        if (submoduleName === `/${submodulePath}`) {
          return (listPermissions = {
            create: item.access_retrieve,
            read: item.access_read,
            edit: item.access_edit,
            erase: item.access_delete,
            exportBtn: item.access_export,
            importBtn: item.access_import,
            path: `${item.module_info.relative_link}/${submodulePath}`,
          })
        }
      }
      return true
    })
    if (location.pathname === '/catalog/users') {
      const checkBtnPermissions = permissions.some((permission) => {
        if (permission?.module_info.name === 'UsersPermissions') {
          if (permission?.access_read) return true
          else return false
        }
        return null
      })
      listPermissions.permissionsBtn = checkBtnPermissions
    }
    return setPermissions(listPermissions)
  }, [location.pathname, user])

  return permissions
}

export default usePermissions
